<template>
  <div class="openvip_main">
    <div class="openvip_mb" @click="showOpenvip(false)"></div>
    <div class="openvip_con">
      <div class="openvip_tab">
        <div class="openvip_tabli" :class="viptab == 0 ? 'openvip_tabli_act' : ''" @click="serVipTab(0)">
          <div class="flex_ali">
            <span>普通会员</span>
          </div>
        </div>
        <div class="openvip_tabli" :class="viptab == 1 ? 'openvip_tabli_act' : ''" @click="serVipTab(1)">
          <div class="flex_ali">
            <span>超级会员</span>
          </div>
        </div>
      </div>
      <img class="pos" src="../assets/images/img2/offlogin.png" alt="" @click="showOpenvip(false)">

      <div class="openvip_mod">
        <!-- 普通会员板块 -->
        <div v-if="viptab == 0">
          <p class="openvip_modtit">会员特权</p>
          <img src="../assets/images/img2/vipri.png" class="openvip_ri" />
          <p class="openvip_modtit">会员类型</p>
          <ul class="openvip_list">
            <li :class="item.viptype == viptype ? 'openvip_act' : ''" v-for="(item, index) in jbviplist" :key="index" @click="setViptype(item)">
              <img src="../assets/images/img2/openvip_bg.png" class="openvip_bg"/>
              <div class="openvip_li">
                <p class="openvip_list_mod1">{{ formatTime(item.viptype) }}</p>
                <p>
                  <span class="openvip_list_mod2">￥</span>
                  <span class="openvip_list_mod3">{{ item.rmb }}</span>
                </p>
                <p class="openvip_list_mod4">
                  <span>原价￥{{ item.rmbshow }}</span>
                  <span class="openvip_list_mod4line"></span>
                </p>
                <p class="openvip_list_mod5">{{ item.per }}</p>
              </div>
            </li>
          </ul>
        </div>

        <!-- 超级会员板块 -->
        <div v-if="viptab == 1">
          <p class="openvip_modtit">会员特权</p>
          <img src="../assets/images/img2/svipri.png" class="openvip_ri2" />
          <p class="openvip_modtit">会员类型</p>
          <ul class="openvip_list">
            <li :class="item.viptype == sviptype ? 'opensvip_act' : ''" v-for="(item, index) in jbsviplist" :key="index" @click="setViptype(item)">
              <img src="../assets/images/img2/svipbg.png" class="openvip_bg" />
              <div class="openvip_li">
                <p class="openvip_list_mod1">{{ formatTime(item.viptype) }}</p>
                <p>
                  <span class="openvip_list_mod2">￥</span>
                  <span class="openvip_list_mod3">{{ item.rmb }}</span>
                </p>
                <p class="openvip_list_mod4">
                  <span>原价￥{{ item.rmbshow }}</span>
                  <span class="openvip_list_mod4line"></span>
                </p>
                <p class="openvip_list_mod5">{{ item.per }}</p>
              </div>
            </li>
          </ul>
        </div>

        <p class="openvip_modtit" v-if="user_coupon">
          <span>优惠券</span>
          <span class="openvip_modtit1"
            >优惠券仅购买会员使用，不可拆分、叠加、折现</span
          >
        </p>
        <div class="openvip_coupon" v-if="judgeShowCoupon">
          <div
            class="openvip_couponli"
            v-for="(item, index) in user_coupon"
            :key="index"
            @click="act_coupon = item"
          >
            <img
              src="../assets/images/img2/yhjxz.png"
              class="openvip_coupon_act"
              v-if="item.yhqid == act_coupon.yhqid"
            />
            <div class="openvip_coupon_actoff" v-else></div>
            <div class="openvip_coupon_main">
              <img
                src="../assets/images/img2/yhjbg.png"
                class="openvip_coupon_bg"
              />
              <div class="openvip_coupon_con">
                <div class="openvip_coupon_conl">
                  <p>
                    <span class="openvip_coupon_conl1">￥</span>
                    <span class="openvip_coupon_conl2">{{
                      parseInt(item.rmb)
                    }}</span>
                  </p>
                  <p class="openvip_coupon_conl3">现金卷</p>
                </div>
                <div class="openvip_coupon_conr">
                  <p>{{ item.desp }}</p>
                  <div class="openvip_coupon_time">
                    <span class="fl">{{ item.day }}天</span>
                    <div class="openvip_coupon_timek fl">
                      {{ item.hours }}
                    </div>
                    <span class="fl">:</span>
                    <div class="openvip_coupon_timek fl">
                      {{ item.minutes }}
                    </div>
                    <span class="fl">:</span>
                    <div class="openvip_coupon_timek fl">
                      {{ item.seconds }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="openvip_modtit">
          <span>支付方式</span>
          <span class="openvip_modtit1"
            >会员到期失效，不会自动续费，请放心购买</span
          >
        </p>
        <div class="openvip_pay">
          <div class="openvip_paymod">
            <div class="openvip_payimg" v-loading="!showcode">
              <img :src="code_url" class="openvip_pay_code" v-if="showcode" />
              <p class="openvip_payimgcon" v-if="showcode">
                <img
                  src="../assets/images/img2/wxpay.png"
                  class="openvip_pay_icon"
                />
                <span>微信支付</span>
              </p>
            </div>
          </div>
          <div class="openvip_paymod">
            <div>
              <p v-if="payPrice">
                <span class="openvip_paytext1">扫码支付</span>
                <span class="openvip_paytext2">{{ payPrice }}</span>
                <span class="openvip_paytext1">元</span>
              </p>
              <p class="openvip_paytext3" v-if="act_coupon.rmb">
                已优惠 {{ act_coupon.rmb }}元
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
    //   viptab: 0, //0-普通会员；1-超级会员
      jbsviplist: [], // 超级会员列表
      jbviplist: [], // 普通会员列表
      viptype: "", //当前选中的vip类型
      sviptype: "", //当前选中的svip类型
      code_url: "", //二维码地址
      crgid: "", //支付订单id
      showcode: false, //二维码加载动画显示状态
      user_coupon: [], //用户可用优惠卷列表
      act_coupon: {}, //当前选中的优惠卷
    };
  },
  props: {},
  mounted() {
    this.getVipList();
    this.selectUserCoupon();
  },
  destroyed() {
    clearInterval(this.paytime);
    clearInterval(this.coupontime);
  },
  computed: {
    ...mapState(["viptab"]),
    // 计算支付价格
    payPrice() {
      let vip_price;
      let coupon_price = this.act_coupon.rmb ? Number(this.act_coupon.rmb) : 0;
      if (this.viptab == 0) {
        this.jbviplist.forEach((item) => {
          if (item.viptype == this.viptype) {
            vip_price = Number(item.rmb);
          }
        });
      } else {
        this.jbsviplist.forEach((item) => {
          if (item.viptype == this.sviptype) {
            vip_price = Number(item.rmb);
          }
        });
      }

      return vip_price - coupon_price;
    },
    // 判断优惠卷是否可以使用
    judgeShowCoupon() {
      let vip_price;
      if (this.viptab == 0) {
        this.jbviplist.forEach((item) => {
          if (item.viptype == this.viptype) {
            vip_price = parseInt(item.rmb);
          }
        });
      } else {
        this.jbsviplist.forEach((item) => {
          if (item.viptype == this.sviptype) {
            vip_price = parseInt(item.rmb);
          }
        });
      }
      let max = parseInt(this.act_coupon.rmbtj);
      return vip_price < max ? false : true;
    },
  },
  methods: {
    ...mapMutations(["showOpenvip"]),
    // 优惠卷倒计时计数器
    setCouponTime() {
      this.coupontime = setInterval(() => {
        this.user_coupon.forEach((item, index) => {
          this.$set(
            this.user_coupon[index],
            "day",
            this.getTimeLeft(item.etime, "day")
          );
          this.$set(
            this.user_coupon[index],
            "hours",
            this.getTimeLeft(item.etime, "hours")
          );
          this.$set(
            this.user_coupon[index],
            "minutes",
            this.getTimeLeft(item.etime, "minutes")
          );
          this.$set(
            this.user_coupon[index],
            "seconds",
            this.getTimeLeft(item.etime, "seconds")
          );
        });
      }, 1000);
    },
    //优惠卷计时器计算函数
    getTimeLeft(datetimeTo, type) {
      // 计算目标与现在时间差（毫秒）
      let time1 = new Date(datetimeTo).getTime();
      let time2 = new Date().getTime();
      let mss = time1 - time2;

      // 将时间差（毫秒）格式为：天时分秒
      let days = parseInt(mss / (1000 * 60 * 60 * 24));
      let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = parseInt((mss % (1000 * 60)) / 1000);
      if (type == "all") {
        return days + "天" + hours + "时" + minutes + "分" + seconds + "秒";
      } else if (type == "day") {
        return days;
      } else if (type == "hours") {
        return hours;
      } else if (type == "minutes") {
        return minutes;
      } else if (type == "seconds") {
        return seconds;
      }
    },
    // 查询用户可用优惠卷
    selectUserCoupon() {
      let self = this;
      let url =
        self.$store.state.base_api + self.$store.state.base_url.qryusercoupon;
      this.$request.postHttp({}, url, (decData) => {
        self.user_coupon = decData.model;
        if (self.judgeShowCoupon) self.act_coupon = decData.model[0];
        self.setCouponTime();
      });
    },
    // 切换vip头部tab
    serVipTab(tab) {
      this.$store.commit("showOpenvip",{val:true,tab:tab})
      console.log(this.viptab)
      this.openVip();
    },
    // 选择vip类型
    setViptype(item) {
      this.viptab == 0
        ? (this.viptype = item.viptype)
        : (this.sviptype = item.viptype);
      this.openVip();
    },
    // 获取vip列表
    getVipList() {
      let self = this;
      let json = {
        ctime: this.$store.state.userrich.ctime,
        isvalidvip: this.$store.state.userrich.isvalidvip,
        viptype: this.$store.state.userrich.viptype,
        isvalidsvip: this.$store.state.userrich.isvalidsvip,
        sviptype: this.$store.state.userrich.sviptype,
      };
      let url =
        this.$store.state.base_api +
        this.$store.state.base_url.qryuserjbviplist;
      let getRes = function (decdata) {
        self.jbsviplist = JSON.parse(decdata.model.jbsviplist);
        self.jbviplist = JSON.parse(decdata.model.jbviplist);
        self.viptype = self.jbviplist[0].viptype;
        self.sviptype = self.jbsviplist[0].viptype;
        self.openVip();
      };
      this.$request.postHttp(json, url, getRes);
    },
    // 格式化vip类型
    formatTime(type) {
      //vip类型： 1.包月vip 2.包季vip 3.包年vip 4.终身vip 6.包天vip
      if (type == "1") return "包月vip";
      if (type == "2") return "包季vip";
      if (type == "3") return "包年vip";
      if (type == "4") return "终身vip";
      if (type == "6") return "包天vip";
    },
    // 开通vip
    openVip() {
      // 判断登录状态
      if (this.$globalFun.judgeNotLogin(this)) return;
      let self = this;
      self.showcode = false;
      self.code_url = "";
      let json = {
        viptype: this.viptab == 0 ? this.viptype : "",
        sviptype: this.viptab == 1 ? this.sviptype : "",
        paytype: 2,
        extdata: JSON.stringify({ yhqid: this.act_coupon.yhqid }),
        ish5: 4,
      };
      let url = this.$store.state.base_api + this.$store.state.base_url.openvip;
      let getRes = function (decdata) {
        self.code_url = decdata.model.orderparams4webchat.code_url;
        self.crgid = decdata.model.crgid;
        self.showcode = true;
        self.verifyPay();
      };
      this.$request.postHttp(json, url, getRes);
    },
    // 验证支付
    verifyPay() {
      let self = this;
      clearInterval(self.paytime);
      this.paytime = setInterval(() => {
        if (self.crgid == "") return;
        let url =
          self.$store.state.base_api + self.$store.state.base_url.qryorderinfo;
        let json = {
          crgid: self.crgid,
        };
        self.$request.postHttp(json, url, (decdata) => {
          if (decdata.model.status !== "1") return;
          //支付成功清除计时器
          clearInterval(self.paytime);
          self.$store.commit('showOpenvip',false)
          self.$globalFun.getUserInfo(self);
          self.$alert("成功开通vip", "提示", {
            confirmButtonText: "确定",
          });
        });
      }, 3000);
    },
  },
};
</script>

<style>
.openvip_payimgcon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.openvip_payimgcon img {
  margin-right: 10px;
}
.openvip_coupon_actoff {
  width: 18px;
  height: 18px;
  border: 1px solid #999999;
  border-radius: 100%;
}
.openvip_paytext3 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
.openvip_paytext2 {
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 32px;
}
.openvip_paytext1 {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 22px;
}
.openvip_payimg {
  width: 140px;
  height: 170px;
  padding: 10px;
  background-color: #f8f8f8;
  border-radius: 10px;
}
.openvip_pay_icon {
  width: 20px;
  height: 20px;
}
.openvip_pay_code {
  width: 120px;
  height: 120px;
  margin-bottom: 6px;
}
.openvip_paymod {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.openvip_pay {
  display: flex;
  align-content: center;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 30px;
}
.openvip_coupon_conl3 {
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  line-height: 17px;
}
.openvip_coupon_conl2 {
  font-size: 32px;
  font-weight: 600;
  color: #ffffff;
  line-height: 32px;
}
.openvip_coupon_conl1 {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  line-height: 22px;
}
.fl {
  float: left;
}
.openvip_coupon_timek {
  width: 19px;
  height: 22px;
  background: #ec2c51;
  border-radius: 4px;
  color: #74b9ff;
  margin: 0 3px;
}
.openvip_coupon_time {
  display: inline-block;
  margin-top: 6px;
}
.openvip_coupon_conr {
  width: 62%;
  text-align: center;
}
.openvip_coupon_conl {
  width: 38%;
  text-align: center;
}
.openvip_coupon_con {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.openvip_coupon_bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.openvip_coupon_main {
  width: 280px;
  height: 80px;
  position: relative;
  margin-left: 16px;
}
.openvip_coupon_act {
  width: 18px;
  height: 18px;
}
.openvip_couponli {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.openvip_coupon {
  display: flex;
  align-items: center;
  margin-top: 12px;
}
.openvip_modtit1 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
  margin-left: 16px;
}
.opensvip_act .openvip_bg {
  display: block;
}
.opensvip_act .openvip_list_mod1 {
  color: #de1c31;
  background: linear-gradient(135deg, #ffbe0e 0%, #fe8a06 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.opensvip_act .openvip_list_mod2 {
  color: #de1c31;
  background: linear-gradient(135deg, #ffbe0e 0%, #fe8a06 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.opensvip_act .openvip_list_mod3 {
  color: #de1c31;
  background: linear-gradient(135deg, #ffbe0e 0%, #fe8a06 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.opensvip_act .openvip_list_mod4 {
  color: #de1c31;
  background: linear-gradient(135deg, #ffbe0e 0%, #fe8a06 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.opensvip_act .openvip_list_mod5 {
  color: #de1c31;
  background: linear-gradient(135deg, #ffbe0e 0%, #fe8a06 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.opensvip_act .openvip_list_mod4line {
  background: linear-gradient(135deg, #ffbe0e 0%, #fe8a06 100%);
}
.openvip_act .openvip_bg {
  display: block;
}
.openvip_act .openvip_list_mod1 {
  color: #de1c31;
  background: linear-gradient(90deg, #ff4b4b 0%, #a14bff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.openvip_act .openvip_list_mod2 {
  color: #de1c31;
  background: linear-gradient(90deg, #ff4b4b 0%, #a14bff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.openvip_act .openvip_list_mod3 {
  color: #de1c31;
  background: linear-gradient(90deg, #ff4b4b 0%, #a14bff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.openvip_act .openvip_list_mod4 {
  color: #de1c31;
  background: linear-gradient(90deg, #ff4b4b 0%, #a14bff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.openvip_act .openvip_list_mod5 {
  color: #de1c31;
  background: linear-gradient(90deg, #ff4b4b 0%, #a14bff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.openvip_act .openvip_list_mod4line {
  background: linear-gradient(90deg, #ff4b4b 0%, #a14bff 100%);
}

.openvip_bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: none;
}
.openvip_li {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
}
.openvip_list_mod5 {
  font-size: 12px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #666666;
  line-height: 17px;
}
.openvip_list_mod4 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
  display: inline-block;
  margin: 4px 0 10px;
  position: relative;
}
.openvip_list_mod4line {
  width: 100%;
  height: 1px;
  background-color: #999;
  position: absolute;
  top: 50%;
  left: 0;
}

.openvip_list_mod3 {
  font-size: 36px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #666666;
  line-height: 36px;
}
.openvip_list_mod2 {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #666666;
  line-height: 28px;
}
.openvip_list_mod1 {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #666666;
  line-height: 20px;
  margin: 10px 0;
}
.openvip_list li {
  width: 220px;
  height: 134px;
  background: #f8f8f8;
  border-radius: 10px;
  text-align: center;
  position: relative;
  margin-left: 24px;
  cursor: pointer;
}
.openvip_list li:first-of-type {
  margin-left: 0;
}
.openvip_list {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.openvip_ri {
  max-width: 100%;
  height: 60px;
  margin-top: 10px;
}
.openvip_ri2 {
  max-width: 100%;
  height: 130px;
  margin-top: 10px;
}
.openvip_modtit {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 22px;
  margin-top: 20px;
}
.openvip_mod {
  width: 100%;
  padding: 0px 40px;
}
.openvip_tabli_act {
  background-color: #fff !important;
}
.openvip_tabli span {
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 25px;
}
.openvip_tab {
  width: 100%;
  height: 57px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.openvip_tabli {
  width: 50%;
  height: 100%;
  background-color: #eeeeee;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
}
.openvip_main {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.openvip_mb {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.openvip_con {
  width: 788px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  position: absolute;
  left: 50%;
  margin-left: -394px;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 2;
}
.btn_close{
    display: flex;
    justify-content: space-between;
    /* margin-right: 20px; */
}
.pos{
    width: 14px;
    height: 14px;
    position: absolute;
    right: 20px;
    top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/openvip.vue